const menu = document.getElementById('menu');
const menuButton = document.getElementById('menu-button');
const menuButtonClose = document.getElementById('menu-button-close');
const menuClipShape = document.getElementById('menu-clip-shape');

// svg paths
const path1 = "M907.991,323.431C919.384,252.158 1031.01,195.52 1092.38,187.167C1153.74,178.814 1216.68,213.985 1257.66,245.866C1298.64,277.746 1323.87,432.33 1289.8,470.259C1255.72,508.188 1259.01,542.746 1214.07,580.478C1184.52,605.28 1071.73,641.874 985.176,599.056C898.626,556.237 876.455,520.73 907.991,323.431Z";
const path2 = "M927.038,339.706C938.431,268.433 1038.68,238.029 1100.04,229.675C1161.4,221.322 1216.68,213.985 1257.66,245.866C1298.64,277.746 1279.4,420.341 1289.8,470.259C1300.96,523.864 1259.01,542.746 1214.07,580.478C1184.52,605.28 1039.7,663.744 985.176,599.056C922.941,525.223 895.502,537.005 927.038,339.706Z";
const path3 = "M942.059,339.842C964.81,257.314 1063.92,251.019 1125.29,242.666C1186.65,234.312 1178.63,261.752 1219.61,293.632C1260.59,325.512 1279.4,420.341 1289.8,470.259C1300.96,523.864 1272.37,587.141 1214.07,580.478C1167.5,575.157 1049.18,653.646 994.653,588.958C932.418,515.125 888.958,532.459 942.059,339.842Z";

// Morpths SVG
const paths = [path1, path2, path3];
let currentPath = path1;

// Get Mobile Scale
function getMenuMaskScale() {
    return window.innerWidth <= 768 ? 3.5 : 2.5; // larger scale for mobile
}

// Flubber SVG Morph Function
function morphMaskPath(from, to, duration = 2000) {
    const interpolator = flubber.interpolate(from, to);
    const start = performance.now();

    // EaseInOutCubic
    function easeInOutCubic(t) {
        return t < 0.5
            ? 4 * t * t * t
            : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function animate(now) {
        let t = Math.min(1, (now - start) / duration);
        t = easeInOutCubic(t); // apply easing
        const d = interpolator(t);
        menuClipShape.setAttribute('d', d);
        if (t < 1) {
            requestAnimationFrame(animate);
        } else {
            menuClipShape.setAttribute('d', to);
            currentPath = to;
        }
    }
    requestAnimationFrame(animate);
}

let maskX = window.innerWidth / 2;
let maskY = window.innerHeight / 2;
let maskScale = 0; // 0 = hidden, 1 = fully revealed

const pathOffsetX = 1100;
const pathOffsetY = 400;

menuClipShape.setAttribute('d', path1);
updateMaskPosition(maskX, maskY, maskScale);

function updateMaskPosition(x, y, scale = maskScale) {
    // Compensate for scaling so the mask stays centered on the cursor
    menuClipShape.setAttribute(
        'transform',
        `translate(${x - pathOffsetX * scale}, ${y - pathOffsetY * scale}) scale(${scale})`
    );
}

function morphToRandomPath(duration = 3500) {
    let nextIndex;
    do {
        nextIndex = Math.floor(Math.random() * paths.length);
    } while (paths[nextIndex] === currentPath);
    const nextPath = paths[nextIndex];

    // Inline morphMaskPath so we can chain morphs
    const interpolator = flubber.interpolate(currentPath, nextPath);
    const start = performance.now();

    function easeInOutCubic(t) {
        return t < 0.5
            ? 4 * t * t * t
            : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function animate(now) {
        let t = Math.min(1, (now - start) / duration);
        t = easeInOutCubic(t);
        const d = interpolator(t);
        menuClipShape.setAttribute('d', d);
        if (t < 1) {
            requestAnimationFrame(animate);
        } else {
            menuClipShape.setAttribute('d', nextPath);
            currentPath = nextPath;
            // Immediately start morphing to the next path
            morphToRandomPath(duration);
        }
    }
    requestAnimationFrame(animate);
}

// Start the morph loop
morphToRandomPath();


// Animate scale with requestAnimationFrame
function animateMaskScale(target, duration = 400) {
    const start = performance.now();
    const initial = maskScale;
    const delta = target - initial;

    function animate(now) {
        const elapsed = now - start;
        const t = Math.min(elapsed / duration, 1);
        // Ease (easeInOutQuad)
        const eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        maskScale = initial + delta * eased;
        updateMaskPosition(maskX, maskY, maskScale);
        if (t < 1) {
            requestAnimationFrame(animate);
        } else {
            maskScale = target;
            updateMaskPosition(maskX, maskY, maskScale);
        }
    }
    requestAnimationFrame(animate);
}

document.addEventListener('mousemove', (e) => {
    maskX = e.clientX;
    maskY = e.clientY;
    updateMaskPosition(maskX, maskY, maskScale);
});

// Set initial position and scale (hidden)
updateMaskPosition(maskX, maskY, maskScale);

menuButton.addEventListener('click', () => {
    menu.classList.add('menu-open');
    animateMaskScale(getMenuMaskScale(), 400); // use dynamic scale
});

window.addEventListener('resize', () => {
    if (menu.classList.contains('menu-open')) {
        animateMaskScale(getMenuMaskScale(), 200);
    }
});

menuButtonClose.addEventListener('click', () => {
    animateMaskScale(0, 300); // scale down to hide
    setTimeout(() => menu.classList.remove('menu-open'), 300);
});